type RecursiveAppendPx<T> = {
  [K in keyof T]: T[K] extends number
    ? `${T[K]}px`
    : T[K] extends object
      ? RecursiveAppendPx<T[K]>
      : T[K];
};

export default function appendPx<T extends object>(
  obj: T,
): RecursiveAppendPx<T> {
  const newObj: any = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (typeof value === 'number') {
        newObj[key] = `${value}px`;
      } else if (Array.isArray(value)) {
        newObj[key] = value.map(v => `${v}px`);
      } else if (typeof value === 'object' && value !== null) {
        newObj[key] = appendPx(value);
      } else {
        newObj[key] = value;
      }
    }
  }
  return newObj;
}
